export enum SpotlightEvent {
  TRIGGER_SEARCH = 'SpotlightEvent:TRIGGER_SEARCH',
  CLOSE_SEARCH = 'SpotlightEvent:CLOSE_SEARCH'
}
